import type { AddLineItemType } from "@/Shared/Types/lineItemTypes";
import { totalHandlingUnitsForLineItems } from "@/Helpers/lineItemCalculations";
import { lineItemsLimitExplanation } from "./lineItemsLimitExplanation";
import { lineItemsHandlingUnitsLimitExplanation } from "./lineItemsHandlingUnitsLimitExplanation";

/**
 * Why no more line items can be added, or undefined while they still can.
 *
 * Two shipment caps stop adding: the number of line items, and the total
 * handling units. A new line item always carries at least one handling unit,
 * so once the total reaches the cap any new card would put the shipment over
 * it. Line items are checked first so that cap keeps its own wording when both
 * are hit.
 */
export function lineItemsAddLimit(
  lineItems: Array<AddLineItemType>,
  maxLineItems: number,
  maxHandlingUnits: number,
): { disabledMessage: string; explanation: string } | undefined {
  if (lineItems.length >= maxLineItems) {
    return {
      disabledMessage: `Shipments can have up to ${maxLineItems} line items`,
      explanation: lineItemsLimitExplanation(maxLineItems),
    };
  }
  if (totalHandlingUnitsForLineItems(lineItems) >= maxHandlingUnits) {
    return {
      disabledMessage: `Shipments can have up to ${maxHandlingUnits} handling units`,
      explanation: lineItemsHandlingUnitsLimitExplanation(maxHandlingUnits),
    };
  }
  return undefined;
}
